(function () {
  'use strict';

  function initITAAHeader() {
    const header = document.querySelector('[data-itaa-header]');

    if (!header) return;

    if (header.dataset.jsInitialized === 'true') {
      return;
    }

    header.dataset.jsInitialized = 'true';

    /*
     * Sticky header
     */
    function updateHeader() {
      if (window.scrollY > 35) {
        header.classList.add('itaa-header--scrolled');
      } else {
        header.classList.remove('itaa-header--scrolled');
      }
    }

    updateHeader();

    window.addEventListener(
      'scroll',
      updateHeader,
      { passive: true }
    );


    /*
     * Mobile menu
     */

    const toggle = header.querySelector(
      '[data-itaa-menu-toggle]'
    );

    const menu = header.querySelector(
      '[data-itaa-mobile-menu]'
    );

    const closeButtons = header.querySelectorAll(
      '[data-itaa-menu-close]'
    );


    function openMenu() {
      if (!menu) return;

      menu.classList.add('is-open');

      menu.setAttribute(
        'aria-hidden',
        'false'
      );

      if (toggle) {
        toggle.setAttribute(
          'aria-expanded',
          'true'
        );
      }

      document.documentElement.classList.add(
        'itaa-menu-open'
      );
    }


    function closeMenu() {
      if (!menu) return;

      menu.classList.remove('is-open');

      menu.setAttribute(
        'aria-hidden',
        'true'
      );

      if (toggle) {
        toggle.setAttribute(
          'aria-expanded',
          'false'
        );
      }

      document.documentElement.classList.remove(
        'itaa-menu-open'
      );
    }


    if (toggle) {
      toggle.addEventListener(
        'click',
        openMenu
      );
    }


    closeButtons.forEach(function (button) {
      button.addEventListener(
        'click',
        closeMenu
      );
    });


    document.addEventListener(
      'keydown',
      function (event) {
        if (event.key === 'Escape') {
          closeMenu();
        }
      }
    );


    /*
     * Close mobile menu after clicking link
     */

    menu?.querySelectorAll('a').forEach(function (link) {
      link.addEventListener(
        'click',
        closeMenu
      );
    });


    /*
     * Cart count
     */

    function updateCartCount() {

      fetch(
        window.Shopify.routes.root + 'cart.js'
      )
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {

          const counters = document.querySelectorAll(
            '[data-itaa-cart-count]'
          );

          counters.forEach(function (counter) {

            counter.textContent =
              cart.item_count;

            counter.classList.toggle(
              'is-empty',
              cart.item_count === 0
            );

          });

        })
        .catch(function () {});
    }


    updateCartCount();


    document.addEventListener(
      'cart:updated',
      updateCartCount
    );

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initITAAHeader
    );

  } else {

    initITAAHeader();

  }

})();
